import { Dispatch } from 'react-redux';
import { AuthActionCreators, IApplicationState } from "../";
import { IDonorProfileCtScanData } from '@nkr/models/index';

export interface IDonorProfileCtScanResponse {
    data: {
        success: boolean,
        results: IDonorProfileCtScanData
    }
}

export interface IAmbraDirectToViewerResponse {
    data: {
        success: boolean,
        results: string
    }
}

export const ActionCreators = {
    getProfileCtScanData: (donorId: number, centerId: number) => async (dispatch: Dispatch<IApplicationState>): Promise<IDonorProfileCtScanResponse> => {
        let options = {
            url: `${__API__}/center/${centerId}/donor/${donorId}/ct-scan`
        };

        return await dispatch(AuthActionCreators.apiGet(options));
    },
    getAmbraLink: (donorId: number) => async (dispatch: Dispatch<IApplicationState>): Promise<IAmbraDirectToViewerResponse> => {
        let options = {
            url: __API__ + `/ambra/${donorId}/direct-to-viewer-with-auth`
        };

        return await dispatch(AuthActionCreators.apiGet(options));
    },
    deleteAmbraCtScan: (donorId: number) => async (dispatch: Dispatch<IApplicationState>): Promise<IAmbraDirectToViewerResponse> => {
        let options = {
            url: __API__ + `/ambra/${donorId}/ct-scan-rem-with-auth`
        };

        return await dispatch(AuthActionCreators.apiGet(options));
    },
}